import { axiosClient } from 'www/utils'
import Cookies from 'js-cookie'

const baseConfig = {
  withCredentials: true,
}

const smsPhoneLoginPath = '/ajax/phone_send_confirmation_code/'
const callCreateRequestPath = '/services/sso/calls/create_request/'
const callFinishRequestPath = '/services/sso/calls/finish_request/'
const logoutPdPath = '/profile/logout/'

/**
 * Сервис для авторизации через МедТочку.
 */
export default {
  /**
   * Запрос отправки СМС кода на предоставленный телефон.
   * @param {string} phone -
   * @returns {Promise} -
   */
  requestCode(phone) {
    return axiosClient.post(
      smsPhoneLoginPath,
      {
        phone,
      },
      baseConfig,
    )
  },
  /**
   * Запрос на подтверждение номера телефона по коду из СМС.
   * @param {string} phone -
   * @param {string} secretCode -
   * @returns {Promise} -
   */
  confirm(phone, secretCode) {
    return axiosClient.post(
      smsPhoneLoginPath,
      {
        phone,
        secret_code: secretCode,
      },
      baseConfig,
    )
  },
  /**
   * Запрос на вход по коду аутентификации, полученному из ответа на запрос подтверждения номера.
   *
   * @param {object} options -
   * @param {string} options.authCode - код авторизации
   * @param {'ws'|'timer'} options.source - для логов на бэке - место, откуда идет запрос (из сокета, по таймеру)
   * @returns {Promise} -
   */
  login({ authCode, source }) {
    return axiosClient.post(
      window.MEDTOCHKA_URL_LOGIN,
      {},
      {
        ...baseConfig,
        params: {
          code: authCode,
          source,
          time: Date.now(), // для логов на бэке
        },
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      },
    )
  },
  /**
   * Запрос на создание WS для подтверждения номера по звонку
   * @param {string} phone -
   * @returns {Promise} -
   */
  callCreateRequest(phone) {
    return axiosClient.post(
      `${window.MEDTOCHKA_URL}${callCreateRequestPath}`,
      {
        phone,
      },
      baseConfig,
    )
  },
  /**
   * Запрос на завершение WS для подтверждения номера по звонку
   * @param {object} options -
   * @param {string} options.phone -
   * @param {string} options.uuid -
   * @param {'ws'|'timer'} options.source - для логов на бэке - место, откуда идет запрос (из сокета, по таймеру)
   * @returns {Promise} -
   */
  callFinishRequest({ phone, uuid, source }) {
    const clientIdGetParam = `?client_id=${window.MEDTOCHKA_CLIENT_ID}`

    return axiosClient.post(
      `${window.MEDTOCHKA_URL}${callFinishRequestPath}${clientIdGetParam}`,
      {
        phone,
        uuid,
      },
      {
        ...baseConfig,
        params: {
          source,
          time: Date.now(), // для логов на бэке
        },
      },
    )
  },
  /**
   * Разлогинивает юзера на ПД (временно, пока не закончим всю новую авторизацию через МТ)
   * @returns {Promise} -
   */
  logoutPd() {
    return axiosClient.get(logoutPdPath)
  },
  /**
   * Отправляет запрос редиректа на МТ для получения ссылки для авторизации на МТ по запросу с ПД.
   * @returns {Promise} -
   */
  redirectToMt() {
    return axiosClient.get(window.MEDTOCHKA_URL_REDIRECT)
  },
  /**
   * Отправляет запрос по полученной ссылке для авторизации на МТ с ПД.
   * @param {string} receivedUrl -
   * @returns {Promise} -
   */
  loginAfterRedirect(receivedUrl) {
    return axiosClient.post(
      receivedUrl,
      {},
      baseConfig,
    )
  },
}
